import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  getAmountWithCurrency,
  ListItemBox,
  ListItemBoxCell,
  ListItemBoxHeader,
  ListItemBoxRow,
  ListItemBoxText,
  ListItemCont,
  maskName,
  TranslationKeys,
  useTranslation,
  convertAmount,
  exchangeAmountByRate,
} from '@pascal/pascal-core';

export const CurrentAndTopWinnersItem = observer(({ betData }) => {
  const t = useTranslation();

  return (
    <ListItemCont key={`${betData.roundId}_${betData.id}`} animationDelayInSeconds={1.5}>
      <ListItemBox>
        <ListItemBoxHeader>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t('PLAYER_ID')} />
          </ListItemBoxCell>
          <ListItemBoxCell size='small'>
            <ListItemBoxText text={maskName(betData?.playerExternalId || '')} size='big' />
          </ListItemBoxCell>
        </ListItemBoxHeader>
        {/* <ListItemBoxRow> */}
        {/*  <ListItemBoxCell size='big'> */}
        {/*    <ListItemBoxText size='big' text={t('BET_TYPE')} /> */}
        {/*  </ListItemBoxCell> */}
        {/*  <ListItemBoxCell> */}
        {/*    <ListItemBoxText */}
        {/*      style={{ textTransform: 'capitalize' }} */}
        {/*      size='big' */}
        {/*      text={`${marketTypeToName(betData.additionalParams.marketType, t)}`} */}
        {/*    /> */}
        {/*  </ListItemBoxCell> */}
        {/* </ListItemBoxRow> */}
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t(TranslationKeys.Bet)} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              size='big'
              text={`${getAmountWithCurrency({
                amount: convertAmount(exchangeAmountByRate(betData).amount),
                isShowRealCurrency: true,
              })}`}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t('WIN')} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              className='win-color'
              size='big'
              text={`${getAmountWithCurrency({
                amount: convertAmount(exchangeAmountByRate(betData).winAmount),
                isShowRealCurrency: true,
              })}`}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
      </ListItemBox>
    </ListItemCont>
  );
});
